import React, { Component } from 'react';
import { ButtonToolbar, Button, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import Select from "react-select";
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { TableButton } from '../../../TableButton';

export class VerticalComposedDayTimesheetDataIdentifier extends Component {
    constructor(props) {
        super(props);
        let configuration = {
            dayGroups: [],
            availableDayTypes: []
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            if (parsedConfig) {
                configuration = parsedConfig;
            }
        } catch (error) {
            console.error('Error parsing configuration:', error);
        }

        this.state = {
            table: { data: [], loading: true },
            message: { show: false, title: undefined, message: undefined, style: undefined, icon: undefined },
            form: configuration,
            actions: { isLoading: true }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            this.setState({
                table: { data: [], loading: true },
                actions: { isLoading: true }
            });
        }

        const setOfDayTypesCommand = new SetOfDayTypesCommand();
        setOfDayTypesCommand.list(
            (result) => {
                this.setState(state => {
                    let updatedForm = Object.assign({}, state.form);
                    updatedForm.availableDayTypes = result.map(dayType => ({
                        id: dayType.id,
                        name: dayType.name
                    }));

                    return {
                        table: { data: result },
                        actions: { isLoading: false },
                        form: updatedForm
                    };
                });
            },
            (error) => {
                this.setState({
                    message: { show: true, message: error, style: "danger", title: "Erro", icon: "remove" }
                });
            }
        );
    }

    handleFormFieldChange(field) {
        return (e) => {
            const value = e.target.type === "number" ? Number(e.target.value) : e.target.value;
            const updatedForm = this.state.form;
            updatedForm[field] = value;
            this.setState({ form: updatedForm });
        };
    }

    onChangeValue(selectedData, target) {
        this.setState(state => {
            let updatedForm = Object.assign({}, state.form);
            updatedForm[target] = selectedData ? selectedData.value : null;
            return { form: updatedForm };
        });
    }

    handleDayGroupChange = (index, field, value) => {
        let newForm = Object.assign({}, this.state.form);
        let dayGroups = newForm.dayGroups.slice();
        dayGroups[index][field] = value;
        newForm.dayGroups = dayGroups;

        newForm.availableDayTypes = this.getFilteredAvailableDayTypes(
            this.state.table.data.map(dayType => ({ id: dayType.id, name: dayType.name })),
            dayGroups
        );

        this.setState({ form: newForm });
    };

    getFilteredAvailableDayTypes(allAvailable, dayGroups) {
        const selectedTypes = dayGroups
            .map(group => group.setOfDayTypes)
            .filter(id => id !== null);

        return allAvailable.filter(dayType => !selectedTypes.includes(dayType.id));
    }

    addDayGroup = () => {
        let newForm = Object.assign({}, this.state.form);
        newForm.dayGroups.push({ setOfDayTypes: null, descriptionPt: "", descriptionEn: "" });

        newForm.availableDayTypes = this.getFilteredAvailableDayTypes(
            this.state.table.data.map(dayType => ({ id: dayType.id, name: dayType.name })),
            newForm.dayGroups
        );

        this.setState({ form: newForm });
    };

    removeDayGroup = (index) => {
        let newForm = Object.assign({}, this.state.form);
        newForm.dayGroups.splice(index, 1);

        newForm.availableDayTypes = this.getFilteredAvailableDayTypes(
            this.state.table.data.map(dayType => ({ id: dayType.id, name: dayType.name })),
            newForm.dayGroups
        );

        this.setState({ form: newForm });
    };

    onFinishSelectData = () => {
        const { form } = this.state;

        const data = form.dayGroups.map(group => Number(group.setOfDayTypes));

        const configuration = {
            dayGroups: form.dayGroups,
            availableDayTypes: form.availableDayTypes
        };

        this.props.onSelectData(data);
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                dayGroups: [],
                availableDayTypes: []
            },
            styles: {},
        });
    }

    handleDragStart = (e, index) => {
        e.dataTransfer.setData("index", index);
    };

    handleDragOver = (e) => {
        e.preventDefault();
    };

    handleDrop = (e, newIndex) => {
        e.preventDefault();
        const oldIndex = e.dataTransfer.getData("index");
        if (oldIndex === "" || oldIndex === newIndex) return;

        const newForm = { ...this.state.form };
        const draggedItem = newForm.dayGroups[oldIndex];
        newForm.dayGroups.splice(oldIndex, 1);
        newForm.dayGroups.splice(newIndex, 0, draggedItem);

        this.setState({ form: newForm });
    };

    renderDayGroups() {
        const { form } = this.state;
        const { dayGroups, availableDayTypes } = form;

        if (!availableDayTypes || availableDayTypes.length === 0) {
            return <LoadingSpinner />;
        }

        const options = form.availableDayTypes.map(dayType => ({
            value: dayType.id,
            label: dayType.name
        }));

        return (
            <div className="day-groups-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="col-day-type">Tipo de Dia</th>
                            <th className="col-desc-pt">Descrição PT</th>
                            <th className="col-desc-en">Descrição EN</th>
                            <th className="col-actions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dayGroups.map((group, index) => {
                            const selectedOption = options.find(option => Number(option.value) === group.setOfDayTypes);

                            return (
                                <tr key={index} draggable={true}
                                    onDragStart={(e) => this.handleDragStart(e, index)}
                                    onDragOver={this.handleDragOver}
                                    onDrop={(e) => this.handleDrop(e, index)}>
                                    <td className="col-day-type">
                                        <Select
                                            options={options}
                                            value={selectedOption}
                                            onChange={selected => this.handleDayGroupChange(index, 'setOfDayTypes', selected ? selected.value : null)}                                        />
                                    </td>
                                    <td className="col-desc-pt">
                                        <FormControl
                                            type="text"
                                            value={group.descriptionPt}
                                            onChange={e => this.handleDayGroupChange(index, 'descriptionPt', e.target.value)}
                                            placeholder="Descrição (PT)"
                                        />
                                    </td>
                                    <td className="col-desc-en">
                                        <FormControl
                                            type="text"
                                            value={group.descriptionEn}
                                            onChange={e => this.handleDayGroupChange(index, 'descriptionEn', e.target.value)}
                                            placeholder="Descrição (EN)"
                                        />
                                    </td>
                                    <td className="col-actions">
                                        <span className="tooltip-icon">
                                            <i className="icon-network"></i>
                                        </span>
                                        <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.removeDayGroup(index)} />
                                    </td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td colSpan="3" className="no-groups-text"> </td>
                            <td className="col-actions" style={{ textAlign: 'center' }}>
                                <TableButton icon="icon-plus" title="Adicionar" onClick={() => this.addDayGroup()} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { message, actions } = this.state;
        if (actions.isLoading) return <LoadingSpinner />;

        return (
            <div>
                <Form>
                    <FormGroup>
                        <ControlLabel>GRUPOS VERTICAIS</ControlLabel>
                        {this.renderDayGroups()}
                    </FormGroup>
                </Form>

                <ButtonToolbar className="mt-4">
                    <Button bsStyle="default" onClick={this.onFinishSelectData}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message} 
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.setState({ message: { show: false } })}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/VerticalComposedDayTimesheetDataIdentifier.js